
export const JsEvents = {
  SetCustomerHandle: 'setCustomerHandle',
  SetAuthToken: 'setAuthToken',
}

export function isEventAllowed(eventName) {
  return !!~Object.keys(JsEvents).map(name => JsEvents[name]).indexOf(eventName)
}

export const HOST_WINDOW = '__HOST__';

export const sendToCbjs = (action, data) => {
  if(isEventAllowed(action)) {
    // send message to cbInstance in parent window, event will be handled by chargebee.js host actions
    window.cbjsLoader.then(() => {
      window.parent.postMessage({
        cbEvent: true,
        targetWindowName: HOST_WINDOW,
        srcWindowName: HOST_WINDOW,
        message: {
          action: action,
          data: data,
        }
      }, '*')
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/cbjs-helper.js